import { useQuery } from '@tanstack/react-query';
import { GetListAgency, UserWalletCompanyInfoService } from 'services/openapi';

import { AgencyQueryKeys } from './constants';

type GetListAgencyDTO = {
  companyId: string;
  page: number;
  pageSize: number;
};

export const useGetAgenciesQuery = (variables: GetListAgencyDTO) => {
  const queryKey = [AgencyQueryKeys.GET_AGENCY_INFO];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetListAgency, Error>({
    queryKey,
    queryFn: () =>
      UserWalletCompanyInfoService.companyControllerAgencyFindAll(
        variables.companyId,
        variables.page,
        variables.pageSize,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: !!variables,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data?.data,
    isError,
    queryKey,
    refetch,
  };
};
